import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isSupabaseAuthReturn } from '../lib/authContinue';

// Pages that read the Supabase token from the URL themselves (clinic invite accept / password setup) must not be forwarded.
const SKIP = new Set(['/auth/callback', '/verify-email', '/clinic-accept-invite', '/clinic-password-setup']);

/**
 * Supabase confirmation sometimes returns to the Site URL (the homepage)
 * instead of /auth/callback. Move that code or token onto the callback
 * route so the session is created and the patient reaches the dashboard.
 */
const AuthReturnForwarder = () => {
  const location = useLocation();

  useEffect(() => {
    if (SKIP.has(location.pathname)) return;
    const search = location.search || '';
    const hash = window.location.hash || '';
    const hashReturn = /(?:access_token|token_hash|code)=/.test(hash);
    if (!isSupabaseAuthReturn(search) && !hashReturn) return;
    window.location.replace(`/auth/callback${search}${hash}`);
  }, [location.pathname, location.search]);

  return null;
};

export default AuthReturnForwarder;
